import type { ReactNode } from "react";
import { ToolbarPillRow } from "@-/dev.improve.haniverse.components.ui.toolbar.button.view";
import { PrimaryControlsStripToolbar } from "#primary-controls-strip-toolbar";

/** Deck-style accordion chrome: shared glass row, muted surface, and 9px control spacing. */
export function PrimaryControlsStripAccordion({
  actions,
  children,
  className = "relative shrink-0",
  floating = false,
  hasLeadingActions = Boolean(actions),
  stripFade = false,
}: {
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  /** See `PrimaryControlsStripToolbar`: the page scroller runs beneath this bar. */
  floating?: boolean;
  /** Also reserve the menu lane when the route body owns its actions. */
  hasLeadingActions?: boolean;
  /** Non-accordion siblings may retain the shared scrolling-content fade. */
  stripFade?: boolean;
}) {
  return (
    <PrimaryControlsStripToolbar
      className={className ?? "relative shrink-0"}
      fadeInset={stripFade ? 9 : 0}
      floating={floating}
      pointerEvents="box-none"
      stripFade={stripFade}
    >
      <ToolbarPillRow accessibilityRole="tablist" hasLeadingActions={hasLeadingActions}>
        {children}
      </ToolbarPillRow>
      {actions}
    </PrimaryControlsStripToolbar>
  );
}
